export const APP_TITLE = 'M. Eugène';
export const APP_TAGLINE = 'La copro, enfin simple.';
